import { render, staticRenderFns } from "./SalesBreakdownCmp.vue?vue&type=template&id=ad529502&scoped=true&"
import script from "./SalesBreakdownCmp.vue?vue&type=script&lang=js&"
export * from "./SalesBreakdownCmp.vue?vue&type=script&lang=js&"
import style0 from "./SalesBreakdownCmp.vue?vue&type=style&index=0&id=ad529502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad529502",
  null
  
)

export default component.exports